"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calendar = void 0;
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
function Calendar({ size = 20, color = '#fff', }) {
    return (react_1.default.createElement(react_native_svg_1.default, { viewBox: "0 0 67.6 73.45", width: size, height: size },
        react_1.default.createElement(react_native_svg_1.G, { id: "Ebene_2", "data-name": "Ebene 2" },
            react_1.default.createElement(react_native_svg_1.G, { id: "Ebene_1-2", "data-name": "Ebene 1" },
                react_1.default.createElement(react_native_svg_1.Path, { fill: color, d: "M58.76,5.85H52V1.9a1.5,1.5,0,1,0-3,0v4h-30V1.5a1.5,1.5,0,0,0-3,0V5.85H8.84A8.85,8.85,0,0,0,0,14.69V64.61a8.86,8.86,0,0,0,8.84,8.84H58.76a8.86,8.86,0,0,0,8.84-8.84V14.69A8.85,8.85,0,0,0,58.76,5.85Zm-49.92,2h7.23v4.9a1.5,1.5,0,0,0,3,0V7.85H49v5.3a1.5,1.5,0,0,0,3,0V7.85h6.73a6.85,6.85,0,0,1,6.84,6.84v2.69H2V14.69A6.85,6.85,0,0,1,8.84,7.85Zm49.92,63.6H8.84A6.85,6.85,0,0,1,2,64.61V19.38H65.6V64.61A6.85,6.85,0,0,1,58.76,71.45Z" })))));
}
exports.Calendar = Calendar;
